import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';

interface SessionFilterToggle {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** A labelled switch in the list's filter column, styled like the toggles beside it. */
const SessionFilterToggleComponent: React.FC<SessionFilterToggle> = ({ label, checked, onChange }) => (
  <div style={{ marginBottom: '8px' }}>
    <Row spacing="200" alignmentVertical="center">
      <Toggle checked={checked} onChange={onChange} size="small" aria-label={label} />
      <Text type="b200">{label}</Text>
    </Row>
  </div>
);

export default SessionFilterToggleComponent;
